import { render, staticRenderFns } from "./DetailChickBySex.vue?vue&type=template&id=50826a32"
import script from "./DetailChickBySex.vue?vue&type=script&lang=js"
export * from "./DetailChickBySex.vue?vue&type=script&lang=js"
import style0 from "./DetailChickBySex.vue?vue&type=style&index=0&id=50826a32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports